const INITIAL_STATE ={
    title: '',
    content: '',
    img: null,
    imgError: '',
    link: '',
    sendState: '',
    Vpromo: null,
    valor: null,
}
export default (state = INITIAL_STATE, action) => {
    switch(action.type){
        case 'TITLE':
            return { ...state, title: action.payload }
        case 'CONTENT':
            return { ...state, content: action.payload }
        case 'IMG':
            return { ...state, img: action.payload }
        case 'IMG_ERROR':
            return { ...state, imgError: action.payload }
        case 'LINK':
            return { ...state, link: action.payload }
        case 'SEND_STATE':
            return { ...state, sendState: action.payload }
        case 'PROMOCAO':
            return { ...state, Vpromo: action.payload }
        case 'VALOR':
            return { ...state, valor: action.payload }
        default: 
            return state
    }
}


// WEBPACK FOOTER //
// ./src/redux/reducers/promo.js